import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';

const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;

export function convertDates(obj: any): any {
  if (obj === null || obj === undefined) return obj;

  if (typeof obj === 'string' && ISO_DATE_REGEX.test(obj)) {
    return new Date(obj);
  }

  if (Array.isArray(obj)) {
    return obj.map(convertDates);
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).reduce((acc, key) => {
      acc[key] = convertDates(obj[key]);
      return acc;
    }, {} as any);
  }

  return obj;
}

@Injectable()
export class DateInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      map(event => {
        if (event instanceof HttpResponse && event.body && req.responseType !== 'arraybuffer') {
          return event.clone({ body: convertDates(event.body) });
        }
        return event;
      })
    );
  }
}
